export default {
  wallet: {
    title: 'Token Wallet',
    credits: 'tokens',
    availableCredits: 'Available Tokens',
    manage: 'Manage Tokens',
    purchase: 'Purchase Tokens',
    processing: 'Processing...',
    save: 'Save',
    discount: 'Save',
    comparedToBase: 'vs base package',
    comparedToPrevious: 'vs previous package',
    viewHistory: 'View Transaction History',
    buyCredits: 'Buy Tokens',
    modalDescription: 'Purchase tokens to unlock premium features.',
    modalDescriptionFreelancer:
      'Purchase tokens to accept quote requests and bid on public projects.',
    modalDescriptionRecruiter: 'Purchase tokens to post jobs and attract qualified freelancers.',
    selectPackage: 'Select a package',
    noPackages: 'No token packages available at the moment.',
    paymentSuccessMessage: 'Your payment was successful. Tokens have been added to your wallet.',
    paymentFailedMessage: 'The payment failed. Please try again.',
    retry: 'Retry',
  },
  credits: {
    insufficientTitle: 'Insufficient Tokens',
    insufficientMessage:
      'You need {{required}} tokens to {{action}}, but you only have {{current}} tokens.',
    required: 'Required',
    current: 'Current balance',
    needed: 'Tokens needed',
    buyCredits: 'Buy Tokens',
  },
  actions: {
    alliance_request: 'send an alliance request',
    accept_quote_request: 'accept this quote request',
    join_proposal: 'join this proposal',
    submit_public_proposal: 'submit a public proposal',
    post_public_job: 'post a public job',
  },
  packages: {
    starter: 'Starter Pack',
    popular: 'Popular',
    professional: 'Professional Pack',
    enterprise: 'Enterprise Pack',
  },
  history: {
    title: 'Transaction History',
    date: 'Date',
    action: 'Action',
    amount: 'Amount',
    balance: 'Balance',
    noTransactions: 'No transactions yet',
    purchase: 'Token Purchase',
    consumption: 'Token Used',
  },
  costs: {
    alliance_request: '3 tokens (from 4th request)',
    accept_quote_request: '5 tokens',
    join_proposal: '3 tokens',
    submit_public_proposal: '5 tokens',
    post_public_job: '10 tokens',
    free: 'Free',
  },
} as const;
